<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="tab-hd flex-center-center">
                        <div class="u-btn r-1" :class="{'active' : type == 1}" @click="type = 1"></div>
                        <div class="u-btn r-2" :class="{'active' : type == 2}" @click="type = 2"></div>
                    </div>

                    <div class="record-view">
                        <div class="table-head"></div>
                        <div class="table-view">
                            <vuescroll>
                                <table>
                                    <thead>
                                        <tr>
                                            <td style="width: 160px;">{{ type == 1 ? '获得' : '赠送' }}时间</td>
                                            <td style="width: 160px;">{{ type == 1 ? '获得' : '赠送' }}途径</td>
                                            <td>{{ type == 1 ? '获得' : '赠送' }}内容</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in record_list" :key="index">
                                            <td class="time" style="width: 160px;">{{ item.createTime.slice(5) }}</td>
                                            <td style="width: 160px;">{{ item.source == 1 ? '抽奖' : item.type == 1 ? '分享' : '赠送' }}</td>
                                            <td>{{ item.giftName }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </vuescroll>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.record-modal{
    width: 708px;
    height: 580px;
    background-image: url(~@/assets/images/modal/bg-modal-record.png);
}

.title{
    width: 426px;
    height: 31px;
    margin: 0 auto 25px;
    background-image: url(~@/assets/images/modal/title-record.png);    
}

.tab-hd{
    margin-bottom: 20px;
    .u-btn{
        width: 154px;
        height: 52px;
        margin: 0 20px;

        &.r-1{
            background-image: url(~@/assets/images/modal/btn-get.png);

            &.active{
                background-image: url(~@/assets/images/modal/btn-getD.png);
            }
        }

        &.r-2{
            background-image: url(~@/assets/images/modal/btn-send.png);

            &.active{
                background-image: url(~@/assets/images/modal/btn-sendD.png);
            }
        }        
    }
}

.table-view{
    width: 570px;
    height: 360px;
    margin-left: 65px;
    font-size: 20px;
}

table{
    width: 505px;
    margin: 0 auto;
    text-align: center;
    color: #725132;
    border-collapse: collapse;
}

thead{
    td{
        height: 58px;
        font-size: 20px;
        color: #4e2612;
        background-color: #f0ecea;
    }
}

tbody td{
    height: 58px;
    border-bottom: 1px solid #f3e8d0;
}

tr{
    margin-bottom: 20px;
}

.time{
    color: #a7968f;
}

</style>

<script>
import {
    apiCardRecord,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            text : '',
            record_list : [],
            type : 1,
            active : 1,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    watch : {
        type : {
            handler(newVal, oldVal) {
               this.call_record();                  
            },
            deep: true
        },              
    },          
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
        closeModal(){
            this.destroyElement()
        },
        call_record(){

            apiCardRecord({type : this.type}).then(
                res => { this.record_list = res.data; },
                rej => { this.$toast(rej.message); }
            )
        },             
    },    
}
</script>